// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".empty{align-items:center;color:var(--gray);display:flex;flex-direction:column;gap:4px;justify-content:center;padding:40px 0;text-align:center;width:100%}.empty--error{color:var(--red)}@media(max-width:576px){.empty{min-height:25vh}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
